module.exports = __webpack_public_path__ + "img/table43_02.8b7a5245.png";